class Toolbarmobile extends HTMLElement {
  connectedCallback() {
    const cfg = typeof theme !== 'undefined' && theme.config ? theme.config : null;
    const mqlSmall =
      (cfg && cfg.mqlSmall) ||
      (typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 749px)').matches);
    const isTouch =
      (cfg && cfg.isTouch) ||
      'ontouchstart' in window ||
      (typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0);
    const enable =
      mqlSmall ||
      isTouch ||
      (typeof Shopify !== 'undefined' && Shopify.designMode);

    if (!enable) return;
    if (this._toolbarMobileInit) return;
    this._toolbarMobileInit = true;

    this._syncActive = this._syncActive.bind(this);
    this._onResize = (typeof theme !== 'undefined' && theme.utils && typeof theme.utils.rafThrottle === 'function' ? theme.utils.rafThrottle : (fn) => fn)(() => {
      this.setHeight();
      this._syncActive();
    });

    this._syncActive();
    this.setHeight();

    window.addEventListener('resize', this._onResize);
    document.addEventListener('scroll', this._syncActive, { passive: true });

    const header = document.querySelector('#header-component');
    if (header) {
      this._headerMo = new MutationObserver(this._syncActive);
      this._headerMo.observe(header, {
        attributes: true,
        attributeFilter: ['data-sticky-state'],
      });
    }
  }

  disconnectedCallback() {
    if (!this._toolbarMobileInit) return;
    this._toolbarMobileInit = false;

    window.removeEventListener('resize', this._onResize);
    document.removeEventListener('scroll', this._syncActive);
    this._headerMo?.disconnect();
    this._headerMo = null;
  }

  /**
   * Keep the mobile bottom bar visible at all times (Home, Shop, Cart, Account).
   * Previously hid when the sticky header was inactive at the top of the page.
   */
  _syncActive() {
    this.classList.add('active');
  }

  setHeight() {
    document.body.style.setProperty('--toolbar-mobile-height', `${this.clientHeight}px`);
  }
}

customElements.define('toolbar-mobile', Toolbarmobile);
